import {
  INITIALIZE_STATE,
  SET_AUTHENTICATED,
  SET_AUTHENTICATED_USER,
  SET_SELECTED_COMPANY,
  SET_SELECTED_ORDER_OF_SERVICE,
  SET_SELECTED_CONTROL_PANEL,
  SET_SELECTED_STANDARD,
} from './mutation-types'

export default {
  [INITIALIZE_STATE](state) {
    if (localStorage.getItem('selected_company')) {
      state.selected_company = JSON.parse(
        localStorage.getItem('selected_company'),
      )
    } else {
      state.selected_company = null
    }

    if (localStorage.getItem('selected_order_of_service')) {
      state.selected_order_of_service = JSON.parse(
        localStorage.getItem('selected_order_of_service'),
      )
    } else {
      state.selected_order_of_service = null
    }

    if (localStorage.getItem('selected_standard')) {
      state.selected_standard = JSON.parse(
        localStorage.getItem('selected_standard'),
      )
    } else {
      state.selected_standard = null
    }
  },

  [SET_AUTHENTICATED](state, value) {
    state.authenticated = value
  },

  [SET_AUTHENTICATED_USER](state, value) {
    state.authenticated_user = value
    if (value == null) {
      localStorage.removeItem('selected_company')
      localStorage.removeItem('selected_order_of_service')
      localStorage.removeItem('selected_standard')
    }
  },

  [SET_SELECTED_COMPANY](state, value) {
    state.selected_company = value
    localStorage.setItem('selected_company', JSON.stringify(value))
  },

  [SET_SELECTED_ORDER_OF_SERVICE](state, value) {
    state.selected_order_of_service = value
    localStorage.setItem('selected_order_of_service', JSON.stringify(value))
  },

  [SET_SELECTED_CONTROL_PANEL](state, value) {
    state.selected_control_panel = value
  },

  [SET_SELECTED_STANDARD](state, value) {
    state.selected_standard = value
    localStorage.setItem('selected_standard', JSON.stringify(value))
  },

  set_companies_dropdown_has_more(state, value) {
    state.company_dropdown.has_more = value
  },

  set_companies_dropdown_companies(state, value) {
    state.company_dropdown.companies = value
  },

  set_companies_dropdown_page(state, value) {
    state.company_dropdown.page = value
  },

  increment_companies_dropdown_page(state) {
    state.company_dropdown.page++
  },

  set_companies_dropdown_loading(state, value) {
    state.company_dropdown.loading = value
  },

  set_orders_of_service_dropdown_has_more(state, value) {
    state.order_of_service_dropdown.has_more = value
  },

  set_orders_of_service_dropdown_orders_of_service(state, value) {
    state.order_of_service_dropdown.orders_of_service = value
  },

  set_orders_of_service_dropdown_page(state, value) {
    state.order_of_service_dropdown.page = value
  },

  increment_orders_of_service_dropdown_page(state) {
    state.order_of_service_dropdown.page++
  },

  set_orders_of_service_dropdown_loading(state, value) {
    state.order_of_service_dropdown.loading = value
  },
}
